import React, { useContext, useMemo } from 'react';
import { Box, Link, Stack, Typography } from '@mui/material';
import { GridCellParams } from '@mui/x-data-grid-pro';

import { translate as t } from 'hooks/useTranslations';
import { LegacyArchivedManualsContext } from '../context';
import { QuickSearch } from 'components/_atoms';
import { ArchivedManualItem } from 'views/App/Portal/Policy/_types/manuals/draft';
import GridSection, { ColumnDef } from 'components/_layouts/GridSection';
import PageToolbar from '_lex/_atoms/PageToolbar';

/** Content-only component for Legacy (KMS) History tab (no layout wrapper) */
export const LegacyKMSHistoryTabContent: React.FC = () => {
  const { manuals, manualsQuery, params, updateParams } = useContext(LegacyArchivedManualsContext);

  const columns: ColumnDef = useMemo(
    () => ({
      name: {
        header: t('policy.manuals.properties.name'),
        flex: 2,
        renderer: (params: GridCellParams) => {
          const row = params.row;
          if (!row) return null;
          return (
            <Stack>
              <Link href={`./legacy/${row.id}`}>
                <Typography
                  variant='h6'
                  sx={{ fontWeight: 'semibold' }}
                >
                  {row.name}
                </Typography>
              </Link>
            </Stack>
          );
        },
      },
    }),
    [t]
  );

  return (
    <Box sx={{ display: 'grid', gridTemplateRows: 'auto 1fr', gap: 4, minHeight: 0 }}>
      <PageToolbar
        leftItems={
          <QuickSearch
            id='legacy_archived_manuals_keyword_search'
            initialValue={params.q || ''}
            onChange={(val) => updateParams({ q: val })}
            placeholder={t('policy.legacyArchivedManuals.search.placeholder')}
          />
        }
      />
      <GridSection
        columns={columns}
        data={manuals}
        query={manualsQuery}
      />
    </Box>
  );
};

export default LegacyKMSHistoryTabContent;
